import React from 'react';

const MessagesSection = () => {
  const messages = [
    {
      image: '/images/members/Suri.png',
      name: 'Dr. Punamji Suri',
      designation: 'President, DAVCMC',
      location: 'New Delhi',
      message: 'I extend a warm welcome to all not only on site but also on website. D.A.V. Velankar College of Commerce, Solapur is a part of the fabric of DAV College Trust & Management Society, New Delhi.'
    },
    {
      image: '/images/members/Chopra.png',
      name: 'Shri. Maheshji Chopra',
      designation: 'Local Secretary,',
      location: 'Dayanand Institution, Solapur',
      message: 'I welcome you all to this great institution --a temple of higher learning which will help all to blossom, empower and to be sensitive human beings.'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_solapur-shop-preview/artifacts/yyl8q6ks_svshinde.jpeg',
      name: 'Dr. S. V. Shinde',
      designation: 'I/C Principal, DAV Velankar',
      location: 'College of Commerce, Solapur',
      message: 'Welcome to D.A.V. Velankar College of Commerce, Solapur website. The purpose of this webpage is to provide parents, students and community a bird\'s eye view of a wealth and information of our college.'
    }
  ];

  return (
    <div className="py-12 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {messages.map((person, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="bg-gradient-to-r from-[#000066] to-[#000099] p-6">
                <div className="flex justify-center">
                  <div className="bg-white rounded-lg overflow-hidden border-4 border-white shadow-lg w-48 h-64">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="w-full h-full object-contain object-center"
                    />
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h4 className="text-xl font-bold text-center text-[#000066] mb-1">
                  {person.name}
                </h4>
                <p className="text-sm font-semibold text-center text-gray-600 mb-1">
                  {person.designation}
                </p>
                <p className="text-sm text-center text-gray-500 mb-4">
                  {person.location}
                </p>
                <p className="text-sm text-gray-700 text-justify leading-relaxed">
                  {person.message}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MessagesSection;